import { useNavigate } from 'react-router-dom';
import { geschaetzteAktuelleSaisonId, saisonIdZuName } from '../utils/saison';

function Einladung() {
  const navigate = useNavigate();

  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px'
    }}>
      <div style={{
        background: 'white',
        borderRadius: '20px',
        padding: '50px 40px',
        maxWidth: '600px',
        textAlign: 'center',
        boxShadow: '0 20px 60px rgba(0,0,0,0.3)'
      }}>
        <div style={{
          width: '150px',
          height: '150px',
          margin: '0 auto 30px',
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          borderRadius: '30px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '80px',
          boxShadow: '0 10px 30px rgba(102, 126, 234, 0.4)'
        }}>
          🏈
        </div>
        
        <h1 style={{
          fontSize: '42px',
          color: '#2d3748',
          marginBottom: '15px',
          fontWeight: '800'
        }}>
          NFL Tippspiel
        </h1>
        
        <div style={{
          fontSize: '24px',
          color: '#667eea',
          marginBottom: '30px',
          fontWeight: '600'
        }}>
          Saison {saisonIdZuName(geschaetzteAktuelleSaisonId())}
        </div>
        
        <p style={{
          fontSize: '18px',
          color: '#4a5568',
          lineHeight: '1.8',
          marginBottom: '35px'
        }}>
          Hey! 👋<br/><br/>
          Ich lade dich ein zu unserem privaten NFL Tippspiel!<br/>
          Tippe Ergebnisse, sammle Punkte und gewinne Ruhm & Ehre! 🏆
        </p>
        
        <div style={{
          background: '#f7fafc',
          borderRadius: '15px',
          padding: '25px',
          marginBottom: '35px',
          textAlign: 'left'
        }}>
          {[
            { icon: '🎯', text: 'Tippe alle NFL-Spiele der Saison' },
            { icon: '🏆', text: 'Sammle Achievements & Badges' },
            { icon: '📊', text: 'Live-Rankings & Statistiken' },
            { icon: '🎁', text: 'Bonusfragen mit Extra-Punkten' },
            { icon: '💬', text: 'Community-Board zum Austausch' },
            { icon: '🔔', text: 'Push-Benachrichtigungen vor Deadlines' }
          ].map((feature, idx) => (
            <div key={idx} style={{
              display: 'flex',
              alignItems: 'center',
              marginBottom: idx === 5 ? 0 : '15px',
              fontSize: '16px',
              color: '#2d3748'
            }}>
              <div style={{
                fontSize: '28px',
                marginRight: '15px',
                minWidth: '40px'
              }}>
                {feature.icon}
              </div>
              <div>{feature.text}</div>
            </div>
          ))}
        </div>
        
        <button
          onClick={() => navigate('/register')}
          style={{
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            color: 'white',
            padding: '18px 50px',
            borderRadius: '50px',
            border: 'none',
            fontSize: '20px',
            fontWeight: 'bold',
            cursor: 'pointer',
            boxShadow: '0 10px 30px rgba(102, 126, 234, 0.4)',
            transition: 'transform 0.3s, box-shadow 0.3s'
          }}
          onMouseOver={(e) => {
            e.currentTarget.style.transform = 'translateY(-3px)';
            e.currentTarget.style.boxShadow = '0 15px 40px rgba(102, 126, 234, 0.6)';
          }}
          onMouseOut={(e) => {
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = '0 10px 30px rgba(102, 126, 234, 0.4)';
          }}
        >
          🚀 Jetzt mitmachen!
        </button>
        
        <div style={{
          marginTop: '30px',
          fontSize: '14px',
          color: '#a0aec0'
        }}>
          Melde dich an und sei dabei! 🎉
        </div>
      </div>
    </div>
  );
}

export default Einladung;